import * as WashingIcons from "assests";

const WashingMap = {};

for (let i = 1; i <= 34; i++) {
  WashingMap[i] = WashingIcons[`Washing_${i}`];
}

export default WashingMap;
